module.exports = __webpack_public_path__ + "static/img/image_home_product_01.3a430cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_product_01.png
// module id = G/w6
// module chunks = 10